<template>
  <div>
    <v-text-field
      v-if="conversor"
      ref="textFieldLitros"
      v-model="litros"
      :disabled="disabled"
      placeholder="xxx,xx"
      label="Litros"
      @keydown="onKeydownLitros"
      prepend-icon="mdi-water"
      hint="Enter para convertir a kg"
    >
      <template v-slot:append>
        <!-- Botón para convertir kilos (formateado) a litros -->
        <v-btn
          icon
          @click="convertirLitrosAKilos"
          :disabled="disabled"
          title="Convertir litros a kg"
        >
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
      </template>
    </v-text-field>

    <!-- TEXT FIELD FORMATEADO -->
    <v-text-field
      ref="textFieldKilos"
      v-model="selectedLocal"
      prepend-icon="mdi-gauge"
      :label="label"
      :disabled="disabled"
      :placeholder="placeholder"
      @keydown="onKeydown"
      type="number"
      hint="Enter para convertir a litros"
    >
      <template v-slot:append>
        <!-- Botón para convertir kilos (formateado) a litros -->
        <v-btn
          icon
          @click="convertirKilosALitros"
          :disabled="disabled"
          title="Convertir kilos a litros"
        >
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'KilosInputComponent',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: {
      type: Number,
      default: 0.0,
    },
    rules: Array,
    focus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    conversor: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Gas Granel (Kg)'
    },
    placeholder: {
      type: String,
      default: 'Ingrese cantidad de kilos (xxx.xxx,xxx)'
    },
  },
  data () {
    return {
      litros: null,
      formateado: null,
      actualizandoInternamente: false
    }
  },
  computed: {
    selectedLocal: {
      get () {
        return this.selected;
      },
      set (value) {
        this.$emit('change', parseFloat(value));
      }
    },
  },
  watch: {
    formateado(newVal) {
    //   if (this.actualizandoInternamente) return;
    //   const valor = parseFloat(newVal.toString().replace(',', '.'));
    //   if (!isNaN(valor) && valor > 0) {
    //     const litros = parseFloat((valor / 0.51).toFixed(3));
    //     if (litros !== this.litros) {
    //       this.actualizandoInternamente = true;
    //       this.litros = litros;
    //       this.onChange(valor); // kilos
    //       this.actualizandoInternamente = false;
    //     }
    //   } else {
    //     this.formateado = '0,000';
    //   }
    },

    // litros(val) {
    //   if (this.actualizandoInternamente) return;

    //   if (val && val > 0) {
    //     const kilos = parseFloat((val * 0.51).toFixed(3));
    //     const nuevoFormateado = this.formatearNumero(kilos);
    //     if (nuevoFormateado !== this.formateado) {
    //       this.actualizandoInternamente = true;
    //       this.formateado = nuevoFormateado;
    //       this.onChange(kilos);
    //       this.actualizandoInternamente = false;
    //     }
    //   } else {
    //     this.formateado = '0,000';
    //   }
    // },

    // selected(newValue) {
    //   this.formateado = this.formatearNumero(newValue);
    //   this.litros = parseFloat((newValue / 0.51).toFixed(3));
    // },

    focus(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.textField.focus();
        });
      }
    },
  },
  methods: {
    // onChange(kilos) {
    //   if (kilos && kilos > 0) {
    //     this.selectedLocal = parseFloat(kilos.toFixed(3));
    //     this.formateado = this.formatearNumero(kilos);
    //   }
    // },
    onKeydownLitros(event) {
      const key = event.key;
      const isDigit = key >= '0' && key <= '9';
      const isCommaOrDot = key === ',' || key === '.';
      const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Space'].includes(key);
      const currentValue = event.target.value;
      const alreadyHasDecimal = currentValue.includes(',') || currentValue.includes('.');

      if (isCommaOrDot && alreadyHasDecimal) {
        event.preventDefault();
      }

      if (!isDigit && !isCommaOrDot && !isControlKey) {
        event.preventDefault();
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        this.convertirLitrosAKilos()
      }
    },
    onKeydown(event) {
      const key = event.key;
      const isDigit = key >= '0' && key <= '9';
      const isCommaOrDot = key === ',' || key === '.';
      const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Space'].includes(key);
      const currentValue = event.target.value;
      const alreadyHasDecimal = currentValue.includes(',') || currentValue.includes('.');

      // if (isCommaOrDot && alreadyHasDecimal) {
      //   event.preventDefault();
      // }

      // if (!isDigit && !isCommaOrDot && !isControlKey) {
      //   event.preventDefault();
      // }
      if (event.key === 'Enter') {
        event.preventDefault();
        this.convertirKilosALitros()
      }
    },
    formatearNumero(value) {
      const numero = parseFloat(value.toString().replace(',', '.'));
      if (isNaN(numero)) return '';
      const numeroFormateado = numero.toFixed(3);
      let [parteEntera, parteDecimal] = numeroFormateado.split('.');
      parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return `${parteEntera},${parteDecimal}`;
    },
    convertirKilosALitros() {
      // 1 litro = 0.51 kg
      // 196.078 litros
      // kilos = litros * 0.51 }
      // litros = kilos / 0.51 
      const kilos = parseFloat(this.selectedLocal.toString().replace(',', '.'));
      if (!isNaN(kilos) && kilos > 0) {
        this.litros = parseFloat((kilos / 0.51).toFixed(3));
      }
    },
    convertirLitrosAKilos() {
      const litros = parseFloat(this.litros.toString().replace(',', '.'));
      if (!isNaN(litros) && litros > 0) {
        this.selectedLocal = parseFloat((litros * 0.51).toFixed(3));
      }
    }
  }
}
</script>